import React from 'react';
import { Col } from 'reactstrap';
import Slider from 'react-slick';

import { WhitePanel } from '../../../../components';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

const coverageList = [
  {
    backgroundImage: 'url(https://s3.amazonaws.com/honeyguide/assets/test/lp.jpg)',
    text:
      'Putting the HoneyGuide app ahead of its competitors, maps and trail descriptions can be used offline, so you can dip in and out of reception as you drop into mountain valleys without losing functionality',
    url:
      'https://www.lonelyplanet.com/news/2016/06/29/nepal-goes-hi-tech-new-app-trekking/',
  },
  {
    backgroundImage:
      'url(https://s3.amazonaws.com/honeyguide/assets/test/besthike.jpg)',
    text:
      'The number of trekkers is close to fifty thousand per year, but only a handful know the fact that Phuraputi also runs a small kitchen garden and serves organic vegetables to her guests.',
    url: 'https://besthike.com/2018/09/07/new-app-trekking-in-nepal/',
  },
  {
    backgroundImage:
      'url(https://s3.amazonaws.com/honeyguide/assets/test/woldbank.jpg)',
    text:
      'Digital entrepreneurs often talk excitedly about disrupting industries, but rarely do you find such excitement when talking about guidebooks. Ashish Shrestha, one of the founders of Honeyguide, wants to give travelers to Nepal a better all-around experience, from booking their travel to navigating the trails and learning about the local culture.',
    url:
      'http://www.infodev.org/articles/transforming-tourism-nepal-one-trek-time',
  },
  {
    backgroundImage:
      'url(https://s3.amazonaws.com/honeyguide/assets/test/businessworld.jpg)',
    text:
      'Guidebooks are dead!! Millennial travelers have no patience with its format or content. They want the technology to bend around their needs. While they are trekking, they don’t want a guidebook, they want a trekking app. And they want the technology to make them instant experts. HoneyGuide’s Trekking in Nepal provides just that through its features like Mountain Finder, context sensitive Placecards, Deviation Alerts, complete lodge info in a small offline package.',
    url:
      'http://bwdisrupt.businessworld.in/article/7-Startups-in-Nepal-That-Caught-Our-Eye-/23-06-2016-99539/',
  },
  {
    backgroundImage:
      'url(https://s3.amazonaws.com/honeyguide/assets/test/kimkim.jpg)',
    text:
      "HoneyGuide is Nepal's first trekking guide app. Pick your trek, then select categories of interest (mountains, flowers, animals, culture, etc.) so that you can preview and learn about what you'll come across.",
    url: 'https://www.kimkim.com/c/best-apps-for-nepal',
  },
];

const settings = {
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  swipe: true,
  arrows: false,
  dots: false,
  lazyLoad: true,
};

const CoverageSection = () => (
  <Col lg="4">
    <WhitePanel className="mb-4">
      <h2>We are Covered By</h2>
      <Slider {...settings} className="coverage-slide mt-4">
        {coverageList.map(({ backgroundImage, url, text }) => (
          <div key={text} className="item">
            <div className="hex">
              <a href={url} rel="noopener noreferrer" target="_blank">
                <div
                  className="item-hex"
                  style={{ backgroundImage: backgroundImage }}
                />
              </a>
            </div>
            <div className="item-text">
              <p className="quote">{text} </p>
            </div>
          </div>
        ))}
      </Slider>
    </WhitePanel>
  </Col>
);

export default React.memo(CoverageSection);



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/StaticSections/CoverageSection.js